import lore from "../../assets/lore.mp4";
import React, { useEffect } from "react";

import "aos/dist/aos.css";
import Aos from "aos";
function Presentations(props) {
  useEffect(() => {
    Aos.init({ duration: 3000 });
  });
  return (
    <a id="lore" href>
      <div className="flex flex-col md:flex-row lg:justify-around bg-[#0A0912] w-full z-30 p-10 2xl:px-[350px] md:px-40 xl:px-[250px] md:pb-[150px] ">
        <div data-aos="zoom-in" className="z-10 md:mt-10 md:w-5/12 2xl:w-4/12">
          <h1 className="text-transparent  bg-clip-text mb-8 font-bold bg-gradient-to-r from-[#8926B6] to-[#EABCFF] text-2xl md:text-3xl lg:text-5xl 2xl:text-[56px] ">
            The Lore
          </h1>

          <p
            data-aos="zoom-out"
            className="mt-5 tracking-tight letter-spacing:-0.05em text-[#747397]   text-[18px]"
          >
            The Handitars have mastered the art of helping each other. This
            great skill has helped them create a thriving world called the
            HandiVerse. The HandiVerse, an alternate universe to our own, is
            powered by giving.
          </p>
          <p className="mt-5 tracking-tight letter-spacing:-0.05em text-[#747397] text-[18px]">
            Handitars travel across the multiverse to give a hand to those who
            need one, and to spread the great power of giving. That’s how they
            roll!
          </p>
          <p className="mt-5 tracking-tight letter-spacing:-0.05em text-[#747397] text-[18px]">
            Handitars come in many forms, from movie stars to sports stars,
            hip-hop artists to pop icons. The one thing they have in common is
            giving.
          </p>
        </div>

        <div
          data-aos-anchor-placement="top-center"
          className="z-10 md:mt-[-110px] w-full md:w-7/12 h-full lg:w-5/12 "
        >
          <div
            style={{ overflow: "hidden" }}
            id="circleWithAvatar"
            className="relative flex justify-center h-full circleWithAvatar "
          >
            <video
              loop
              preload="true"
              autoPlay
              playsInline
              muted
              className="w-full md:w-11/12 lg:w-full rounded-md 2xl:w-full md:mt-[150px] mt-[50px]"
              src={lore}
              alt=""
            />
          </div>
        </div>
      </div>
    </a>
  );
}

export default Presentations;
